
import { useState } from "react";

import { Grid, TextField } from "@mui/material";
import { LayoutCrearDoc } from "../../layouts";
import { useForm } from "../../../hooks";
import { BotonesAndCargando } from "../../components/botones";
import { startSavingCategoria } from "../../../services";



const initCategoria = {
    nombre: '',
    tags: '',
    primero: 0,
    segundo: 0,
    tercero: 0,
    cuarto: 0,
    quinto: 0,
    sexto: 0,
    septimo: 0,
};



export const CrearCategoria = () => {


    const [ values, handleInputChange, setValues, ] = useForm(initCategoria);
    const { nombre, tags, primero, segundo, tercero, cuarto, quinto, sexto, septimo } = values;
    const [cargando, setCargando] = useState(false);



    const handleCrearCategoria = async(e) => {
        e.preventDefault();
        setCargando(true);
        const resp = await startSavingCategoria(values)
        setCargando(false);
        if( resp ){
            setValues( initCategoria );
        }
        
    }


    return (


        <LayoutCrearDoc titulo={'Crear Categoria'} add={false}>
            <form onSubmit={ handleCrearCategoria } >

                <Grid container spacing={3} sx={{mt:3}}>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Nombre'
                            type='text'
                            placeholder='Nombre'
                            fullWidth
                            name="nombre"
                            value={ nombre }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Primero'
                            type='number'
                            placeholder='Primero'
                            fullWidth
                            name="primero"
                            value={ primero }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Segundo'
                            type='number'
                            placeholder='Segundo'
                            fullWidth
                            name="segundo"
                            value={ segundo }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Tercero'
                            type='number'
                            placeholder='Tercero'
                            fullWidth
                            name="tercero"
                            value={ tercero }
                            onChange={ handleInputChange } 
                        />
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Cuarto'
                            type='number'
                            placeholder='Cuarto'
                            fullWidth
                            name="cuarto"
                            value={ cuarto }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Quinto'
                            type='number'
                            placeholder='Quinto'
                            fullWidth
                            name="quinto"
                            value={ quinto }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Sexto'
                            type='number'
                            placeholder='Sexto'
                            fullWidth
                            name="sexto"
                            value={ sexto }
                            onChange={ handleInputChange }
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <TextField required
                            variant="outlined"
                            label='Septimo'
                            type='number'
                            placeholder='Septimo'
                            fullWidth
                            name="septimo"
                            value={ septimo }
                            onChange={ handleInputChange } 
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField required
                            variant="outlined"
                            label='Tags (Separar con Coma)'
                            multiline
                            type='number'
                            placeholder='Tags (Separar con Coma)'
                            fullWidth
                            name="tags"
                            value={ tags }
                            onChange={ handleInputChange } 
                            rows={3}
                        />
                    </Grid>
                </Grid>


                <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                    <Grid item xs={12} sm={6} md={5}>
                        <BotonesAndCargando
                            cargando={cargando}
                            titulo='Crear Categoria'
                            titulo2="Loading..."
                            icon1="save"
                            icon2="save"
                            esSubmit
                        />
                    </Grid>
                </Grid>

            </form>
        </LayoutCrearDoc>

    )
}
